import React from 'react';
import { routesByProject } from '../types/global.types';
import TermsAndConditions from '../components/policies/termsAndConditions';
import PrivacyPolicy from '../components/policies/privacyPolicy';

import CopiaCategory from '../modules/copia/copiaCategory';
import AuthWrapper from '../hoc/AuthWrapper';
import { Navigate } from 'react-router-dom';

const Dashboard = React.lazy(() => import('../layout/dashboard'));
const Cerebrum = React.lazy(() => import('../modules/cerebrum'));
const Copia = React.lazy(() => import('../modules/copia'));
const Calendarium = React.lazy(() => import('../modules/calendarium'));
const UnityLayout = React.lazy(() => import('../modules/unityLayout'));
const CopiaLayout = React.lazy(() => import('../modules/copiaLayout'));
const Myspaces = React.lazy(() => import('../modules/myspaces'));
// const PopokProperty = React.lazy(() => import('../modules/popokProperty'));
const AboutUs = React.lazy(() => import('../modules/aboutUs'));
const LandingPage = React.lazy(() => import('../modules/landingPage'));
const ContactUs = React.lazy(() => import('../modules/contactUs'));
const ForBusinesses = React.lazy(() => import('../modules/forBusinesses'));
const RoomScene = React.lazy(() => import('../modules/RoomScene'));
const EstateDetails = React.lazy(() => import('../modules/estateDetails'));
const ApartmentDetails = React.lazy(
  () => import('../modules/apartmentDetails'),
);

export const ProjectsRoutes: routesByProject = {
  95942005: [
    {
      path: '',
      component: AuthWrapper(Dashboard),
      id: 1,
      child: [
        {
          path: '',
          component: Copia,
          id: 1,
          child: [
            {
              path: ':category', // This is where CopiaCategory should be rendered
              component: Copia,
              id: 1,
            },
          ],
        },
        {
          path: 'copia',
          component: Copia,
          id: 2,
          child: [
            {
              path: ':category', // This is where CopiaCategory should be rendered
              component: CopiaCategory,
              id: 1,
            },
          ],
        },
        {
          path: 'copia/restaurants/booking',
          component: LandingPage,
          id: 4,
        },
        {
          path: 'calendarium',
          component: Calendarium,
          id: 6,
        },
        {
          path: 'myspaces',
          component: Myspaces,
          id: 7,
        },
        {
          path: 'terms-and-conditions',
          component: TermsAndConditions,
          id: 8,
        },
        {
          path: 'privacy-policy',
          component: PrivacyPolicy,
          id: 9,
        },
        // {
        //   path: 'popok-property',
        //   component: PopokProperty,
        //   id: 10,
        // },
        {
          path: 'about-us',
          component: AboutUs,
          id: 11,
        },
        {
          path: 'for-businesses',
          component: ForBusinesses,
          id: 12,
        },
        {
          path: 'contact-us',
          component: ContactUs,
          id: 13,
        },
        {
          path: 'spaces',
          component: Cerebrum,
          id: 1,
          child: [
            {
              path: ':category', // This is where CopiaCategory should be rendered
              component: Cerebrum,
              id: 14,
            },
          ],
        },
      ],
    },
    {
      path: 'room/:id',
      component: AuthWrapper(UnityLayout),
      id: 2,
    },
    {
      path: 'copia/constructors/:id',
      component: () => <Navigate to="/copia/constructors" />,
      id: 11,
    },
    {
      path: 'copia/:type/:id/3d',
      component: AuthWrapper(CopiaLayout),
      id: 12,
    },
    {
      path: 'copia/:type/:id',
      component: AuthWrapper(CopiaLayout),
      id: 3,
    },
    {
      path: 'copia/constructors/:constructorId/details',
      component: AuthWrapper(EstateDetails),
      id: 6,
    },
    {
      path: 'copia/constructors/:constructorId/:apartmentId',
      component: AuthWrapper(ApartmentDetails),
      id: 7,
    },
    // {
    //   path: 'copia/:type/:id/:hotelRoomId',
    //   component: AuthWrapper(CopiaLayout),
    //   id: 4,
    // },
    {
      path: 'scene/:id',
      component: RoomScene,
      id: 5,
    },
  ],
};
